var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.483 38.6L18.1245 180C16.3852 183.024 15.4649 186.453 15.4552 189.945C15.4454 193.437 16.3466 196.871 18.0689 199.905C19.7913 202.939 22.2749 205.467 25.2726 207.238C28.2703 209.01 31.6776 209.962 35.1555 210H203.872C207.35 209.962 210.758 209.01 213.755 207.238C216.753 205.467 219.237 202.939 220.959 199.905C222.681 196.871 223.583 193.437 223.573 189.945C223.563 186.453 222.643 183.024 220.904 180L136.545 38.6C134.77 35.661 132.27 33.2312 129.286 31.5448C126.303 29.8585 122.937 28.9725 119.514 28.9725C116.09 28.9725 112.725 29.8585 109.742 31.5448C106.758 33.2312 104.258 35.661 102.483 38.6V38.6Z",
    fill: "#FEDCDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M119.516 90V142",
    stroke: "#E93C3C",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.516 170H119.615",
    stroke: "#E93C3C",
    strokeWidth: 18,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.9369994673ee5ef218e69d62832bbb92.svg";
export { ForwardRef as ReactComponent };